/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useContext } from 'react';
import Context from '../context/context';
import ContextMenu from "./ContextMenu"

const Card = ({ selected_seat, rounded, item, onclickFunction, cursorItemRef, index, seats, visibleContext, setVisibleContext }) => {

  let page = window.location.pathname;
  let timeGap = item?.created_at ? Date.now() - item.created_at : 0;
  let timeGapStr = new Date(timeGap).toUTCString().slice(17, -7);
  const [time, setTime] = useState(page.includes('/page1') && timeGapStr);

  const context = useContext(Context);
  const { currentOrderRef, showWarning } = context;

  useEffect(() => {
    if (page.includes('/page1'))
      setInterval(() => {
        let time_gap = item.created_at && Date.now() - item.created_at
        time_gap = new Date(time_gap)?.toUTCString()?.slice(17, -7)
        setTime(time_gap)
      }, 60000);
  }, [])

  async function itemClickHandle() {
    if (!currentOrderRef.current || +currentOrderRef.current?.payment_status !== 1 || window.location.search?.includes('edit')) {
      onclickFunction({ item_uuid: item.item_uuid, action: "increment", category_uuid: item.category_uuid })
    }
    else showWarning({
      message: 'Adding Items not allowed after Payment is Done',
      classname: 'active-red'
    })
  }

  const color = page?.includes?.('/page2') && item?.item_mode === "1" ? "#4AC959" : "red";
  const seatTitle = (item.title1 ? item.title1 : item.title2)?.split(', ')
  return (
    <>
      {page.includes('/page1') &&
        <>
          <div>
            <button
              className={`card-focus ${rounded ? 'rounded' : ''} ${selected_seat === item.seat_uuid ? 'highlighted-card' : ''}`}
              onContextMenu={(e) => {
                e.preventDefault();
                console.log(item?.created_at)
                if (item?.created_at)
                  setVisibleContext({ id: item.seat_uuid, elemProperties: e.currentTarget.getBoundingClientRect() });
              }}
            >
              <div className={`card ${rounded ? 'rounded' : ''}`}>
                <p className='title2' >{seatTitle?.[0]}{seatTitle?.length > 2 && <small style={{ color: 'grey' }}> +{seatTitle?.length - 1}</small>}</p>
                <p className='caption'>{item.title1 ? item.title2 : ''}</p>
                <div className={`horizontal-line`} style={{ background: `${item.color}` }}></div>
                {item.color !== '#4AC959' && item?.created_at ?
                  <div className='seatTimer'>
                    <div>{time}</div>
                    <div>(Rs.{item.price || 0})</div>
                  </div>
                  : <div style={{ height: "50px" }}></div>
                }
              </div>
            </button>
          </div>
          {item?.created_at && visibleContext?.id === item.seat_uuid &&
            <ContextMenu
              id={item?.order_uuid}
              visibleContext={visibleContext}
              setVisibleContext={setVisibleContext}
              order_type={0}
              seats={seats}
              currentSeat={item?.seat_uuid}
            />
          }
        </>
      }
      {
        page.includes('/page2') &&
        <>
          <div
            className='click-handler-element'
            onClick={itemClickHandle}
            style={{ display: "none" }}
          />
          <div
            onMouseDown={(e) => {
              e.preventDefault();
              itemClickHandle()
            }}
          >
            <button
              className={`card-focus 
              ${rounded ? 'rounded' : ''} 
              ${cursorItemRef?.current === item?.item_uuid ? "highlighted-card" : ""}
              `}
            >
              <div className={`card ${rounded ? 'rounded' : ''}`} style={{ width: "150px", height: "150px" }}>
                <p className='title2' style={{ fontSize: "15px", maxWidth: "130px", height: "50px" }}>
                  {item?.item_name?.length > 42 ? item?.item_name.slice(0, 42) + "..." : item?.item_name}</p>
                <p className='caption'></p>
                <div className={`horizontal-line ${color}`}></div>
                <p className={`price ${color}`}>{item.menu_item_price}</p>
              </div>
            </button>
          </div>
        </>
      }
    </>
  )
}

export default Card